import { useState } from "react";
import { FinancialAnalysisModule } from "./FinancialAnalysisModule";
import { MockFinancialAnalysisService } from "./mock/MockFinancialAnalysisService";

export function FinancialAnalysisPreview() {
  const [service] = useState(() => new MockFinancialAnalysisService());
  return <FinancialAnalysisModule service={service}/>;
}
